<template>
	<div>
		<!-- 重置密码 -->
		<div class="all-center-box">
		    <div class="w-1500">
				<div class="address-box w-100"><router-link to="/">首页</router-link> / <a href="">关于汇利兴</a></div>
				<div class="page-center-box w-100">
					<div class="ksbj-box w-100">
						<div class="box-info1 w-100 text-center">— 找回密码 —</div>
						<div class="box-info2 w-100 center-center">
							<form action="" class="pull-left" method="post">
								<!-- <div class="box2 w-100">
									<label class="radio-inline"><input type="radio" name="type" checked="checked" id="" value="1" @click="radioChoose(1)" />邮箱找回</label>
								</div>
								<div class="box1 w-100">
									<span><i>*</i> 用户名：</span>
									<input type="text" class="text" name="" id="" value="" placeholder="请输入登录用户名" />
								</div>
								<div class="box1 w-100">
									<span><i>*</i> 邮箱：</span>
									<input type="text" class="text" name="" id="" value="" placeholder="请输入注册邮箱" />
								</div> -->
								<!-- <div class="box2 w-100">
									<label class="radio-inline"><input type="radio" name="type" id="" value="2" @click="radioChoose(2)" />手机找回（仅适用于已验证手机）</label>
								</div> -->
								<div class="box1 w-100">
									<span><i>*</i> 手机号码：</span>
									<input type="text" maxlength="11" class="text" name="" id="" v-model="phone" placeholder="请输入已验证的手机号码" />
								</div>

								<div class="box1 w-100 yzm">
									<span><i>*</i> 手机验证码：</span>
									<input type="text" class="text" name="" id="" v-model="vcode" placeholder="请输入手机验证码" />
									<a href="javascript:;" @click="getCode">{{codeBtn.codeText}}</a>
								</div>
                <div class="box1 w-100 yzm">
									<span><i>*</i> 验证码：</span>
									<input type="text" class="text" name="" id="" v-model="vcodeNum" placeholder="请输入验证码" />
									<!-- <img src="../../assets/images/img_8.png" > -->
                  <img @click="getCodeImg" :src="codeImg" />
								</div>
								<div class="box1 w-100">
									<span><i>*</i> 新密码：</span>
									<input type="password" class="text" name="" id="" v-model="password"
										placeholder="请输入8-20位且必须包含字母和数字的密码" />
								</div>
								<div class="box1 w-100">
									<span><i>*</i> 确认密码：</span>
									<input type="password" class="text" name="" id="" v-model="repassword"
										placeholder="请再次输入密码" @blur="passwordCom" />
								</div>
								<div class="btns" @click="reset">提交</div>
							</form>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {resetPassword,getMyCode} from '@/common/http.js';
	import {
		message
	} from '@/common/common.js';
	export default{
		data() {
			return {
				type: 0, // 0 邮箱  1 手机
				password: '',
				repassword: '',
				phone: '',
				vcode: '',
        codeImg: '',
				vcodeNum: '',
				codeBtn: {
					codeTime: 60,
					codeText: '获取验证码',
					codeStatus: true
				},
				rules: {
					phone: {
						rule: /^1[3456789]\d{9}$/,
						msg: '手机号格式错误'
					},
					password: {
						rule: /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,20}$/g,
						msg: '请输入8-20位且必须包含字母和数字的密码'
					},
					vcode: {
						rule: /^[0-9]{4}$/,
						msg: '请输入4位数字验证码'
					}
				}
			}
		},
    mounted() {
      this.getCodeImg()
    },
		methods: {
      getCodeImg () {
      this.codeImg = 'https://hxfahlx.huixinggroup.com/-img-code.htm?d=' + new Date().getTime()
    },
			radioChoose(value) {
				this.type = value
			},
			getCode() {
				if (!this.phone) {
					message({
						message: '手机号不能为空！'
					})
					return;
				}
				if (!this.validate('phone')) {
					return;
				}
				if (!this.codeBtn.codeStatus) {
					message({
						message: '请稍后再试~',
						type: 'warning'
					})
					return;
				}
				// 请求验证码
				const loading = this.$loading({
					lock: true,
					text: '发送中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});
				setTimeout(() => {
					loading.close();
				}, 2000);
				this.VerifyCode()
				this.timerId = setInterval(() => {
					let codetime = this.codeBtn.codeTime
					codetime--
					this.codeBtn.codeTime = codetime
					this.codeBtn.codeText = codetime + 's'
					if (codetime < 1) {
						clearInterval(this.timerId)
						this.codeBtn.codeText = '重新获取'
						this.codeBtn.codeTime = 60
						this.codeBtn.codeStatus = true
						this.isChick = true
					}
				}, 1000)
			},
			async VerifyCode() {
				console.log(this.phone);
				try {
					let {
						msg
					} = await getMyCode({
						mobile: this.phone,
            type: 2
					})
					setTimeout(() => {
						this.$message({
							message: msg,
							type: 'success'
						});
					}, 2000)
				} catch (err) {
					this.$message.error(err.data.msg);
				}
			},
			// 判断验证是否符合要求，合法性校验
			validate(key) {
				let bool = true;
				if (!this.rules[key].rule.test(this[key])) {
					// 提示信息
					this.$message(this.rules[key].msg);
					// 取反
					bool = false;
					return false;
				}
				return bool;
			},
			passwordCom() {
				if (this.repassword != this.password) {
					message({
						message: '两次密码输入不一致！'
					})
				}
			},
			reset() {
					if (!this.phone) {
						message({
							message: '手机号不能为空！'
						})
						return;
					}
					if (!this.validate('phone')) {
						return;
					}
					if (!this.vcode) {
						message({
							message: '请输入手机验证码！'
						})
						return;
					}
					if (!this.validate('vcode')) {
						return;
					}
					if (!this.password) {
						message({
							message: '请输入密码！'
						})
						return;
					}
					if (!this.validate('password')) {
						return;
					}
					if (!this.repassword) {
						message({
							message: '请确认密码！'
						})
						return;
					}
					if (this.repassword != this.password) {
						message({
							message: '两次密码输入不一致！'
						})
						return;
					}
					resetPassword({
						password: this.password,
						repassword: this.repassword,
						phone: this.phone,
						vcode: this.vcode
					}).then(res=>{
						if (res.result) {
							let obj = {
								password: this.password,
								phone: this.phone
							}
							localStorage.setItem('account',JSON.stringify(obj));
							this.$router.push({path: '/'});
							$('.login-eject').fadeIn();
						} else {
							message({
								message: res.data.msg,
								type: 'error'
							})
						}
					})
			}
		}
	}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/pages/resetPassword/resetPassword.vue